import { Box, Typography } from "@mui/material";
import React from "react";
import Countdown from "react-countdown";
import Count from "../../../molecules/Count/Count";
import { Images } from "../../../../helpers/Images";
import { Button } from "@mui/material";
import SportsEsportsRoundedIcon from "@mui/icons-material/SportsEsportsRounded";
import { useNavigate } from "react-router-dom";

const CountDown = () => {
  const navigate = useNavigate()
  return (
    <Box
      sx={{
        width: "100%",
        padding: {
          xs: "50px 20px",
          sm: "50px 60px",
          lg: "50px 120px",
          xl: "100px 120px",
        },
        background: `radial-gradient(1200px 700px at 20% 10%, rgba(35, 174, 244, 0.35), transparent 60%),
          radial-gradient(900px 600px at 90% 30%, rgba(255, 0, 128, 0.22), transparent 55%),
          linear-gradient(180deg, rgba(10, 14, 24, 0.72), rgba(10, 14, 24, 0.72)),
          url(${Images.wedo})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        minHeight: "400px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: "1100px",
          margin: "0 auto",
          textAlign: "center",
        }}
      >
        <Typography
          variant="h1"
          sx={{
            fontSize: { xs: "30px", sm: "44px", md: "56px" },
            lineHeight: 1.1,
            fontWeight: 800,
            letterSpacing: "-0.02em",
            color: "#fff",
            textShadow: "0 10px 30px rgba(0,0,0,0.35)",
          }}
        >
          Welcome to We Do Challenge Championship
        </Typography>
        <Typography
          variant="h2"
          sx={{
            mt: 1.5,
            fontSize: { xs: "14px", sm: "18px", md: "20px" },
            fontWeight: 500,
            color: "rgba(255,255,255,0.82)",
            maxWidth: "820px",
            margin: "0 auto",
          }}
        >
          Ready for 2026 season — countdown to kickoff
        </Typography>

        <Box sx={{ mt: { xs: 3, md: 4 } }}>
          <Countdown
            date={"2026-10-15T00:00:00"}
            intervalDelay={0}
            renderer={(props) => (
              <Count
                days={props.days}
                hours={props.hours}
                minutes={props.minutes}
                seconds={props.seconds}
              />
            )}
          />
        </Box>

        {/* <Box
          sx={{
            mt: 5,
            maxWidth: "850px",
            mx: "auto",
            p: { xs: 3, md: 4 },
            borderRadius: "24px",
            background: "rgba(255,255,255,0.08)",
            backdropFilter: "blur(12px)",
            border: "1px solid rgba(255,255,255,0.15)",
            boxShadow: "0 20px 60px rgba(0,0,0,0.25)",
          }}
        >
          <Typography
            sx={{
              fontSize: { xs: "12px", md: "13px" },
              fontWeight: 700,
              letterSpacing: "0.08em",
              textTransform: "uppercase",
              color: "#23aef4",
              mb: 1,
            }}
          >
            🚀 New Game Release
          </Typography>

          <Typography
            sx={{
              fontSize: { xs: "26px", md: "38px" },
              fontWeight: 800,
              color: "#fff",
              lineHeight: 1.2,
              mb: 1,
            }}
          >
            Try Our New Game{" "}
            <Box
              component="span"
              sx={{
                background:
                  "linear-gradient(90deg,#23aef4 0%,#ff0080 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              ZIKO RUN
            </Box>
          </Typography>

          <Typography
            sx={{
              color: "rgba(255,255,255,0.82)",
              fontSize: { xs: "12px", md: "15px" },
              lineHeight: 1.4,
              maxWidth: "600px",
              mx: "auto",
            }}
          >
            Jump, dodge obstacles, collect rewards, and challenge your
            friends in the exciting world of ZIKO RUN. Test your skills,
            beat high scores, and see how far you can go!
          </Typography>

          <Button
            variant="contained"
            startIcon={<SportsEsportsRoundedIcon />}
            onClick={() => navigate("/game")}
            sx={{
              mt: 2,
              px: 4,
              py: 1.5,
              borderRadius: "14px",
              textTransform: "none",
              fontWeight: 700,
              fontSize: "16px",
              background:
                "linear-gradient(90deg,#23aef4 0%,#ff0080 100%)",
              boxShadow: "0 12px 30px rgba(35,174,244,.35)",
              "&:hover": {
                background:
                  "linear-gradient(90deg,#1d9ee0 0%,#d6006d 100%)",
              },
            }}
          >
            Play ZIKO RUN Now
          </Button>
        </Box> */}
      </Box>

      {/* Kept intentionally minimal; CTA buttons can be re-enabled later. */}
      {/**
       * Previous CTA code removed to keep this section clean.
       */}

      {/*
        <Countdown
          date={"2026-10-15T24:00:00"}
          intervalDelay={0}
          renderer={(props) => (
            <Count
              days={props.days}
              hours={props.hours}
              minutes={props.minutes}
              seconds={props.seconds}
            />
          )}
        />
      */}
    </Box>
  );
};

export default CountDown;
